module.exports = __webpack_public_path__ + "media/images/main_slider/Deposito Berbagi-79cc29962cb3b3ffa82ca5ab6d61e3b1.png";